import { Button } from 'utoniq-ui'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'
import { getRedirectAfterLoginPath } from '@/core/native/storage'

import {
  ProfileInputArtistForm,
  ProfileInputArtistFormProps,
} from './ProfileInputArtistForm'

export * from './fragments'

export type State = {
  hiddenDisplayName: boolean
  hiddenAccountId: boolean
  hiddenInviteCode: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: ProfileInputArtistFormProps['onSubmit']
  onClickAvatar: ProfileInputArtistFormProps['onClickAvatar']
}

export const ProfileInputArtistTemplate: Template<State, Action> = ({
  state,
  onSubmit,
  onClickAvatar,
}) => {
  const { t } = useTranslation('profileInputArtist')
  const { routerPages, routerNames, router } = useRouter()

  return (
    <>
      <Head title={routerNames.ProfileInputArtist} />
      <BaseLayout
        margin
        header={{
          title: t('title'),
          right: (
            <Button
              variant="text"
              color="primary"
              sx={{ whiteSpace: 'nowrap', ml: -6 }}
              onClick={() => {
                getRedirectAfterLoginPath().then(loginPath => {
                  router.push(loginPath.value || routerPages.ConsoleDashboard)
                })
              }}
            >
              {t('skip')}
            </Button>
          ),
        }}
      >
        <ProfileInputArtistForm
          hiddenDisplayName={state.hiddenDisplayName}
          hiddenAccountId={state.hiddenAccountId}
          hiddenInviteCode={state.hiddenInviteCode}
          onSubmit={onSubmit}
          onClickAvatar={onClickAvatar}
        />
      </BaseLayout>
    </>
  )
}
